import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface BoeSubmitPromptCommandProperties extends CommandProperties {
  /**
   * The user's raw prompt text
   */
  prompt: string;
  /**
   * The whiteboard content ID to provide as context
   */
  contentId: string;
}

/**
 * Command to submit a BOE prompt from a whiteboard to AFM's Rovo chat,
 * using the existing content creation flow (no wrapper text added).
 */
export const BoeSubmitPromptCommand =
  createCommand<BoeSubmitPromptCommandProperties>('boe-submit-prompt');
